// extracted by mini-css-extract-plugin
export default {"container":"bidError_container__qEkT6","subContainer":"bidError_subContainer__3vjZL","footer":"bidError_footer__0Znpk"};